import React, { FC } from 'react';
import RolesListPage from './role-list';
import { Routes, Route } from 'react-router-dom';
import RoleInformationPage from 'src/common/components/business/role-information-page';
import { Selector } from 'src/common/types';
import { useTranslation } from 'react-i18next';

const RolesIndex: FC = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route path={`/*`} element={<RolesListPage />} />
      <Route
        path={`/new`}
        element={
          <RoleInformationPage
            header={t('NewRole')}
            maxSelector={Selector.Admin}
            mode="new"
            previousRoute="/roles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'roles', breadcrumbName: t('Roles') },
              { path: 'new', breadcrumbName: t('NewRole') },
            ]}
            canBeAssignedByDefaultToScopeCreator
            canSelectOrganization
          />
        }
      />
      <Route
        path={`/update/:id`}
        element={
          <RoleInformationPage
            header={t('EditRole')}
            maxSelector={Selector.Admin}
            mode="edit"
            previousRoute="/roles"
            routes={[
              { path: '', breadcrumbName: t('Home') },
              { path: 'roles', breadcrumbName: t('Roles') },
              { path: `update`, breadcrumbName: t('EditRole') },
            ]}
            canBeAssignedByDefaultToScopeCreator
            canSelectOrganization
          />
        }
      />
    </Routes>
  );
};

export default RolesIndex;
